<input type="text" [id]="ctrlid" [disabled]="disabled" [placeholder]="placeholder" [(ngModel)]="date"
       (ngModelChange)="gewijzigd($event)" bsDatepicker (blur)="onTouched()"
       [bsConfig]="bsConfig"
       [isDisabled]="disabled"
       [minDate]="toDate(minDate) || undefined"
       [maxDate]="toDate(maxDate) || undefined"
       [placement]="$any(placement)"
>
